import { Injectable, NgZone } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, NavigationEnd, UrlTree, CanActivate } from '@angular/router';

import { AuthService } from '../service/auth.service';
import {Observable, filter, map, of} from 'rxjs';
import { CommonService } from '../../shared/services/common.service';
import { MODULE_CONSTANTS } from '../../shared/constants/constant';
import { roleModuleAccess } from '../../admin/models/user-management/user_models';
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private zone: NgZone, private router: Router, private route: ActivatedRoute, private commonService: CommonService) {

  }

  canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    if (!this.authService.currentUserValue?.success) {
      this.router.navigate(['/auth/signin'], { queryParams: { redirectURL: state.url } });
      return of(false);
    }

    return this.commonService.moduleDetails$.pipe(
        take(1),
        map((modules: roleModuleAccess[]) => {
          const moduleKeys = this.getModuleRoleAccessFromRoute(route);

          const hasAccess = moduleKeys?.some(key =>
              modules?.some(mod => mod.moduleKey === key)
          );

          if (hasAccess || moduleKeys?.includes(MODULE_CONSTANTS.COMMON)) {
            return true;
          }

          console.warn('[Guard] Access denied for module:', moduleKeys);
          return this.router.createUrlTree(['/user-profile']);
        })
    );
  }

  private getModuleRoleAccessFromRoute(route: ActivatedRouteSnapshot): string[] | null {
    return route.data?.['moduleKey'] ?? null;
  }

  getModuleRoleAccess(): any | null {
    let child = this.route.firstChild;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else if (child.snapshot.data && child.snapshot.data['moduleKey']) {
        return child.snapshot.data['moduleKey'];
      } else {
        return null;
      }
    }
    return null;
  }
}
